export enum ScheduleSettingsMode {
    Off = 4,
    On = 5,
    Daily = 1,
    Weekly = 2,
    Range = 3,
}
